module.exports = __webpack_public_path__ + "static/PaulDraws_Kerry-8147a39b29e79527dd27025381f59f1a.jpg";